import { useReactiveVar } from "@apollo/client";
import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useState } from "react";
import * as Styled from "./style";
import { NaviList } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service/navi-list";
import { OldNaviList } from "~/components/blocks/layout/global-navi/desktop/left/dmm-service/old-navi-list";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { isTouchDisplay } from "~/const/device";

export const DmmServiceDesktop = () => {
  const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);
  // TODO: (okita) 新旧API切り替わり時にreference errorが発生するため分岐フラグを作成、API切り替わり後削除する
  const hasBusiness = dmmServiceListData.findIndex((service) => service.name === "ビジネス・法人向け") !== -1;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Styled.DivContainer>
      <Styled.ButtonIconWrapper
        type="button"
        name="dmmServiceList"
        aria-label="dmmServiceList"
        onClick={() => {
          if (!isTouchDisplay) return;
          setIsOpen((prev) => !prev);
        }}
      >
        <Icon name="union" color="GRAY900" />
      </Styled.ButtonIconWrapper>

      <Styled.DivDmmMenuContainer isOpen={isOpen} isTouchDevice={isTouchDisplay}>
        {/* TODO: (okita) 新旧API切り替わり後OldNaviListを削除する */}
        {hasBusiness ? <NaviList /> : <OldNaviList />}
      </Styled.DivDmmMenuContainer>
    </Styled.DivContainer>
  );
};
